<div class="incubatee-div-modal">
  <div class="form_div chart">
    <div class="terms-head mb-3">
      <div class="chart-det">
        <div>
          <h5 class="font-weight-bold mb-3">View Remarks</h5>
        </div>
      </div>
    </div>
    <div class="py-2">
      <p>{{ datas._data }}</p>
      <div class="text-center">
        <button mat-raised-button color="warn" (click)="cancelReason()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
